import React, { useState } from 'react';
import './ClassifierDemo.css';

const CATEGORIES = {
  'Hardware': '#CC1100',
  'Software': '#1A4FCC',
  'Network': '#2E7A30',
  'HR Support': '#C89800',
  'Access': '#7A2E8A',
  'Miscellaneous': '#5a5a54',
  'Storage': '#1A7A7A',
  'Purchase': '#8A5A1A',
};

function ClassifierDemo({ color }) {
  const [text, setText] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    if (!text.trim()) return;
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      // Replace with your real API Gateway URL once deployed
      const response = await fetch('https://q1ru7s0u09.execute-api.us-east-1.amazonaws.com/Prod/classify', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ text }),
      });
      const data = await response.json();
      setResult(data);
    } catch (err) {
      setError('Could not reach the classifier API.');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && e.metaKey) handleSubmit();
  };

  return (
    <div className="demo">
      <div className="section-label">{'// Live demo'}</div>
      <p className="demo-hint">
        Enter an IT support ticket description and the model will classify it into one of 8 categories.
      </p>

      <textarea
        className="demo-input"
        rows={5}
        placeholder="e.g. My laptop won't connect to the office wifi after the recent update..."
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      <div className="demo-hint-small">Cmd+Enter to submit</div>

      <button
        className="keybtn"
        onClick={handleSubmit}
        disabled={loading || !text.trim()}
        style={{ '--btn-color': color, '--btn-shadow': '#771100' }}
      >
        <span className="keybtn-face" style={{ background: color }}>
          {loading ? 'Classifying...' : 'Classify ticket'}
        </span>
        <span className="keybtn-shadow" style={{ background: '#771100' }}></span>
      </button>

      {error && <div className="demo-error">{error}</div>}

      {result && (
        <div className="demo-result">
          <div className="section-label" style={{ marginBottom: '12px' }}>{'// Result'}</div>

          {result.status === 'auto_classified' ? (
            <>
              <div className="result-row">
                <span className="result-label">Classification</span>
                <span
                  className="result-value result-tag"
                  style={{ background: CATEGORIES[result.classification] || color }}
                >
                  {result.classification}
                </span>
              </div>
              <div className="result-row">
                <span className="result-label">Confidence</span>
                <span className="result-value">{(result.confidence * 100).toFixed(1)}%</span>
              </div>
              <div className="confidence-bar-wrap">
                <div
                  className="confidence-bar"
                  style={{
                    width: `${result.confidence * 100}%`,
                    background: result.confidence >= 0.9 ? '#2E7A30' : result.confidence >= 0.8 ? '#C89800' : '#CC1100'
                  }}
                />
              </div>
              <div className="result-status auto">✓ Auto-classified</div>
            </>
          ) : (
            <>
              <div className="result-row">
                <span className="result-label">Confidence</span>
                <span className="result-value">{(result.confidence * 100).toFixed(1)}%</span>
              </div>
              <div className="confidence-bar-wrap">
                <div
                  className="confidence-bar"
                  style={{ width: `${result.confidence * 100}%`, background: '#CC1100' }}
                />
              </div>
              <div className="result-status manual">⚠ Flagged for manual review — confidence below 80%</div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default ClassifierDemo;